import type { ReactNode } from 'react';
import { Flex, Heading } from '@radix-ui/themes';

export function PageHeader({ title, actions }: { title: ReactNode; actions?: ReactNode }) {
  return (
    <Flex justify="between" align="center" gap="3">
      <Heading size="6">{title}</Heading>
      {actions}
    </Flex>
  );
}
